<div class="row p-2 my-2 flex-style">
  <div
    *ngIf="showName"
    class="col-md-7 mat-body-1 displayFlex"
    [ngClass]="{
      'col-md-6': !IsConsentScreen,
      'col-md-4': IsConsentScreen
    }"
  >
    <span
      *ngIf="!IsConsentScreen"
      [innerHTML]="question.safeHtmlContent"
      class="inputLabel-p"
      style="text-align: justify;"
    ></span>

    <span
      *ngIf="IsConsentScreen"
      [innerHTML]="question.consentQuestionLabel || question.safeHtmlContent"
      class="inputLabel-p"
      style="text-align: justify;"
    ></span>

    <span
      style="margin-left: 8px;"
      *ngIf="question.questionToolTip"
    >
      <img
        class="dupIcon-padd iconzoom cursor"
        matTooltip="{{ question.questionToolTip }}"
        src="/assets/icons/information_tooltip.svg"
        alt="info icon"
        matTooltipClass="my-custom-tooltip"
        matTooltipPosition="above"
      />
    </span>
  </div>

  <div
    class="mat-body-1"
    [ngClass]="{
      'col-md-4': showName && !IsConsentScreen,
      'col-md-7': IsConsentScreen
    }"
  >
    <div
      *ngIf="!selectedUser && !showImage"
      class="ml-2"
    >
      <button
        class="btnAddSign w-60"
        (click)="showSignataurePad()"
        [ngClass]="{
          'pt-none': IsReadOnly
        }"
      >
        Add Signature
      </button>
    </div>

    <div
      *ngIf="showImage && imageSrc != null"
    >
      <div
        class="flex-sign"
        [ngStyle]="{
          'flex-direction': IsConsentScreen
            ? 'column'
            : 'row'
        }"
      >
        <img
          src="{{ imageSrc }}"
          style="height: 150px; width: 300px;"
          alt="E-Signature"
        />
      </div>
    </div>

    <div *ngIf="showUserNameAsSign">
      <span>
        {{ selectedUser }}
      </span>
    </div>

    <div
      class="row ml-2 mt-2"
      *ngIf="
        !IsReadOnly &&
        (selectedUser || showImage) &&
        question.responseText != null &&
        question.responseText.length > 0
      "
    >
      <button
        class="btnAddSign"
        (click)="clearAndSignAgain()"
      >
        Clear And Sign Again
      </button>
    </div>

    <div
      *ngIf="
        !showImage &&
        !selectedUser &&
        IsReadOnly
      "
    >
      <span
        style="font-size: 9px; margin-top: 5px;"
      >
        <em>
          No Signature Available
        </em>
      </span>
    </div>

    <div
      *ngIf="
        userRoleDesc &&
        userRoleDesc.toLowerCase() ==
          'group admin'
      "
      style="
        text-align: center;
        overflow: visible;
        margin-left: -400px;
      "
    >
      <span>
        Signed By:
        {{ selectedUser }}
      </span>

      &nbsp;

      <span>
        Signed Role:
        {{ userSignRole }}
      </span>

      &nbsp;

      <span>
        Signed Date:
        {{ formattedEsignDate }}
      </span>
    </div>

    <div
      *ngIf="errormgvisible"
      class="mt-2"
    >
      <div
        class="errormsg"
        *ngFor="let error of errorMessages"
      >
        {{ error }}
      </div>
    </div>
  </div>
</div>

<app-modal
  id="signPopupWindow{{ question.questionId }}"
  *ngIf="!hideSignPopUp"
  [modalSize]="modalSize"
  [modalText]="modalText"
  (modalClose)="close($event)"
  [isDraggable]="true"
>
  <div class="signature-popup-content">
    <div class="signature-subtitle">
      Confirm your name and your signature
    </div>

    <div class="signature-form-row">
      <div class="form-field">
        <label class="field-label">
          Printed/Typed Name:
          <span class="required-star">
            *
          </span>
        </label>

        <div
          class="field-input"
          style="
            background-color: #f5f5f5;
            color: #666;
            cursor: not-allowed;
            padding: 8px;
          "
        >
          {{ selectedUser }}
        </div>

        <label class="field-label">
          Role/title with Provider:
          <span class="required-star">
            *
          </span>
        </label>

        <input
          type="text"
          class="field-input"
          placeholder="Enter your Role"
          (keyup)="onInput($event)"
          [(ngModel)]="userSignRole"
          required
        />

        <label class="field-label">
          Date Attestation Completed:
          <span class="required-star">
            *
          </span>
        </label>

        <div
          class="field-input"
          style="
            background-color: #f5f5f5;
            color: #666;
            cursor: not-allowed;
            padding: 8px;
          "
        >
          {{ formattedEsignDate }}
        </div>
      </div>

      <div class="form-field">
        <label class="field-label ml-2">
          Allowed Signature Types
          <span class="required-star">
            *
          </span>
        </label>

        <div
          class="checkbox-wrapper"
          *ngIf="isESignAllowed"
        >
          <mat-checkbox
            class="pt-2"
            (change)="drawSelect($event)"
            [(ngModel)]="OptionSelectedToDrawSign"
          >
            Draw signature
          </mat-checkbox>
        </div>

        <div
          class="checkbox-wrapper"
          *ngIf="isSSignAllowed"
        >
          <mat-checkbox
            class="pt-2"
            (change)="textSelect($event)"
            [(ngModel)]="OptionSelectedToTypeSign"
          >
            Use /s/ signature
          </mat-checkbox>
        </div>
      </div>
    </div>

    <div
      *ngIf="
        nameFlag ||
        selectedUser == 'undefined'
      "
      class="error-text"
    >
      {{ errorMsg }}
    </div>

    <div
      [hidden]="!OptionSelectedToDrawSign"
      class="signature-canvas-section"
    >
      <div class="canvas-header">
        <span class="canvas-title">
          DRAW YOUR SIGNATURE
        </span>

        <div class="canvas-actions">
          <button
            class="canvas-action-btn clear"
            (click)="clearSign()"
          >
            Clear
          </button>
        </div>
      </div>

      <div class="canvas-container">
        <div class="canvas-drawing-area">
          <signature-pad
            class="signature-pad"
            (onBeginEvent)="drawStart()"
            (onEndEvent)="drawComplete()"
            [options]="signaturePadOptions"
          >
          </signature-pad>
        </div>
      </div>
    </div>

    <div
      [hidden]="!OptionSelectedToTypeSign"
      class="text-signature-section"
    >
      <div class="canvas-header">
        <span class="canvas-title">
          Display /s/ signature
        </span>
      </div>

      <div class="canvas-container s-signature">
        <div class="canvas-text-area">
          <canvas
            #canvasEl
            width="300"
            height="70"
          ></canvas>
        </div>
      </div>
    </div>

    <div
      class="mt-2 errormsg m-0 p-0"
      *ngIf="OptionSelectedToTypeSign"
    >
      Edit the Printed/Typed Name above to modify the /s/ signature
    </div>

    <div class="mt-2">
      <div
        class="errormsg ml-0"
        *ngFor="let entry of validationErrors"
      >
        {{ entry }}
      </div>
    </div>

    <div class="popup-actions mb-4 pb-4">
      <button
        type="submit"
        class="action-btn primary"
        [disabled]="
          !selectedUser ||
          !userSignRole ||
          !esignDate ||
          (!OptionSelectedToDrawSign &&
            !OptionSelectedToTypeSign) ||
          (OptionSelectedToDrawSign &&
            (signaturePad?.isEmpty() ?? true)) ||
          (OptionSelectedToTypeSign &&
            !selectedUser)
        "
        (click)="ok()"
      >
        SIGN AND FINALIZE
      </button>

      <button
        class="action-btn secondary"
        (click)="close($event)"
      >
        CANCEL
      </button>
    </div>
  </div>
</app-modal>